module.exports = __webpack_public_path__ + "img/android.0a47f284.png";